import { __read } from "tslib";
/* eslint-disable @typescript-eslint/no-unsafe-call */
import * as u from '@virtuoso.dev/urx';
import { findMaxKeyValue } from './AATree';
import { domIOSystem } from './domIOSystem';
import { loggerSystem, LogLevel } from './loggerSystem';
import { offsetOf, originalIndexFromItemIndex, sizeSystem } from './sizeSystem';
var SUPPORTS_SCROLL_TO_OPTIONS = typeof document !== 'undefined' &&
    'scrollBehavior' in document.documentElement.style;
export function normalizeIndexLocation(location) {
    var result = typeof location === 'number' ? { index: location } : location;
    if (!result.align) {
        result.align = 'start';
    }
    if (!result.behavior || !SUPPORTS_SCROLL_TO_OPTIONS) {
        result.behavior = 'auto';
    }
    if (!result.offset) {
        result.offset = 0;
    }
    return result;
}
export var scrollToIndexSystem = u.system(function (_a) {
    var _b = __read(_a, 3), _c = _b[0], sizes = _c.sizes, totalCount = _c.totalCount, listRefresh = _c.listRefresh, _d = _b[1], scrollingInProgress = _d.scrollingInProgress, viewportHeight = _d.viewportHeight, scrollTo = _d.scrollTo, smoothScrollTargetReached = _d.smoothScrollTargetReached, headerHeight = _d.headerHeight, footerHeight = _d.footerHeight, log = _b[2].log;
    var scrollToIndex = u.stream();
    var topListHeight = u.statefulStream(0);
    var unsubscribeNextListRefresh = null;
    var cleartTimeoutRef = null;
    var unsubscribeListRefresh = null;
    function cleanup() {
        if (unsubscribeNextListRefresh) {
            unsubscribeNextListRefresh();
            unsubscribeNextListRefresh = null;
        }
        if (unsubscribeListRefresh) {
            unsubscribeListRefresh();
            unsubscribeListRefresh = null;
        }
        if (cleartTimeoutRef) {
            clearTimeout(cleartTimeoutRef);
            cleartTimeoutRef = null;
        }
        u.publish(scrollingInProgress, false);
    }
    u.connect(u.pipe(scrollToIndex, u.withLatestFrom(sizes, viewportHeight, totalCount, topListHeight, headerHeight, footerHeight, log), u.map(function (_a) {
        var _b = __read(_a, 8), location = _b[0], sizes = _b[1], viewportHeight = _b[2], totalCount = _b[3], topListHeight = _b[4], headerHeight = _b[5], footerHeight = _b[6], log = _b[7];
        var normalLocation = normalizeIndexLocation(location);
        var align = normalLocation.align, behavior = normalLocation.behavior, offset = normalLocation.offset;
        var lastIndex = totalCount - 1;
        var index = normalLocation.index;
        if (index === 'LAST') {
            index = lastIndex;
        }
        index = originalIndexFromItemIndex(index, sizes);
        index = Math.max(0, index, Math.min(lastIndex, index));
        var top = offsetOf(index, sizes.offsetTree) + headerHeight;
        if (align === 'end') {
            top =
                top -
                    viewportHeight +
                    findMaxKeyValue(sizes.sizeTree, index)[1];
            if (index === lastIndex) {
                top += footerHeight;
            }
        }
        else if (align === 'center') {
            top =
                top -
                    viewportHeight / 2 +
                    findMaxKeyValue(sizes.sizeTree, index)[1] / 2;
        }
        else {
            top -= topListHeight;
        }
        if (offset) {
            top += offset;
        }
        var retry = function (listChanged) {
            cleanup();
            if (listChanged) {
                log('retrying to scroll to', { location: location }, LogLevel.DEBUG);
                u.publish(scrollToIndex, location);
            }
            else {
                log('list did not change, scroll successful', {}, LogLevel.DEBUG);
            }
        };
        cleanup();
        if (behavior === 'smooth') {
            var listChanged_1 = false;
            unsubscribeListRefresh = u.subscribe(listRefresh, function (changed) {
                listChanged_1 = listChanged_1 || changed;
            });
            unsubscribeNextListRefresh = u.handleNext(smoothScrollTargetReached, function () {
                retry(listChanged_1);
            });
        }
        else {
            unsubscribeNextListRefresh = u.handleNext(u.pipe(listRefresh, watchChangesFor(50)), retry);
        }
        // if the scroll jump is too small, the list won't get rerendered.
        // clean this listener
        cleartTimeoutRef = setTimeout(function () {
            cleanup();
        }, 1200);
        u.publish(scrollingInProgress, true);
        log('scrolling from index to', { index: index, top: top, behavior: behavior }, LogLevel.DEBUG);
        return { top: top, behavior: behavior };
    })), scrollTo);
    return {
        scrollToIndex: scrollToIndex,
        topListHeight: topListHeight,
    };
}, u.tup(sizeSystem, domIOSystem, loggerSystem), { singleton: true });
function watchChangesFor(limit) {
    return function (done) {
        var timeoutRef = setTimeout(function () {
            done(false);
        }, limit);
        return function (value) {
            if (value) {
                done(true);
                clearTimeout(timeoutRef);
            }
        };
    };
}
